import { IconPackOption } from "@nova/constants"
import { iconPackByPrefix } from "./constants"
import store from "integrations/redux/store"
import { Icon } from "@nova/protobuf"
import { zoomToShowPoints } from "features/map/zoom/thunks"

export const iconShapeOptionFromUrl = (url?: string) => {
    for (const [prefix, iconShapeOption] of iconPackByPrefix) {
        if (url?.startsWith(prefix)) return iconShapeOption
    }

    return IconPackOption.Shape
}

export const initialTitleIsPlaceholder = (title: string) =>
    /^(Icon|Point|Line|Text|Polygon|Measurement) \d+$/.test(title)

export const formatIconUrl = (url: string) => {
    const capitalizedName = url
        .split("/")[1]
        .split("_")
        .map((e) => e[0].toUpperCase() + e.slice(1))
        .join("_")
    return `icons/${url.split("/")[0]}/svg/${capitalizedName}.svg`
}

export const zoomToIcon = (entity: Icon) => {
    store.dispatch(zoomToShowPoints({ points: [[entity.longitude, entity.latitude]] }))
}
